import React, { Component } from 'react';
import cloneDeep from 'lodash/cloneDeep';
import Table from '@cloudscape-design/components/table';
import Pagination from '@cloudscape-design/components/pagination';
import Header from '@cloudscape-design/components/header';
import Button from '@cloudscape-design/components/button';
import Box from '@cloudscape-design/components/box';
import Preferences from '@cloudscape-design/components/collection-preferences';
import Alert from '@cloudscape-design/components/alert';
import SpaceBetween from '@cloudscape-design/components/space-between';
import Container from '@cloudscape-design/components/container';
import Modal from '@cloudscape-design/components/modal';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { configStore } from '../stores/config';
import {  playerBanStore } from "../stores/playerHidePayway";
import { playerBanAddModalStore, playerHidePaywayAddModalStore } from "../stores/playerHidePaywayAddModal";
import Grid from "@cloudscape-design/components/grid";
import Select from "@cloudscape-design/components/select";
import Input from "@cloudscape-design/components/input";
import { playerBanEditModalStore, playerHidePaywayEditModalStore } from "../stores/playerHidePaywayEditModal";
import { playerHidePaywayStore } from "../stores/playerHidePayway";

class PlayerHidePayway extends Component {
	constructor(props) {
		super(props);
		this.state = {
			selectedItems: [],
			showDeleteModal: false,
			isDeleting: false,
		};
	}

	componentDidMount() {
		this.props.Interface.loadPlayerHidePayway();
	}

	handleKeyPress = (event) => {
		if (event.detail.key === 'Enter') {
			setTimeout(() => {
				this.props.Interface.loadPlayerHidePayway();
			}, 0);
		}
	};

	handleDeleteSelected = () => {
		if (this.state.selectedItems.length === 0) {
			this.props.Interface.addNoty('Error', 'No items selected for deletion');
			return;
		}
		this.setState({ showDeleteModal: true });
	};

	confirmDelete = async () => {
		const { selectedItems } = this.state;
		const { Interface } = this.props;

		this.setState({ isDeleting: true });

		try {
			const ids = selectedItems.map((item) => item.id);
			await Interface.request('set', {
				class: 'data',
				module: 'playerHidePayway',
				method: 'delete',
			}, { id: ids });

			Interface.addNoty('Success', `${ids.length} player ban(s) deleted successfully`);
			this.setState({ selectedItems: [], showDeleteModal: false });
			Interface.loadPlayerHidePayway();
		} catch (error) {
			Interface.addNoty('Error', error.text || error.toString());
		} finally {
			this.setState({ isDeleting: false });
		}
	};

	render() {
		const { playerHidePayway, setPlayerHidePayway, config, setConfig, setPlayerHidePaywayAddModal, playerHidePaywayAddModal, setPlayerHidePaywayEditModal, playerHidePaywayEditModal } = this.props;
		const { selectedItems, showDeleteModal, isDeleting } = this.state;

		return (
			<Container>
				{playerHidePayway.loaded && playerHidePayway.error.text.length ? (
					<Box margin={{ bottom: 'm' }}>
						<Alert
							type="error"
							header="Error loading data"
							dismissible
							onDismiss={() => setPlayerHidePayway({ ...playerHidePayway, error: { text: '', code: 0, timestamp: 0 } })}
						>
							<Box variant="p">{playerHidePayway.error.text}</Box>
							<hr />
							<Box variant="p">
								Request error code: {playerHidePayway.error.code} | Request timestamp: {playerHidePayway.error.timestamp}
							</Box>
						</Alert>
					</Box>
				) : null}

				<Modal
					visible={showDeleteModal}
					onDismiss={() => this.setState({ showDeleteModal: false })}
					header="Confirm Deletion"
					footer={
						<Box float="right">
							<SpaceBetween direction="horizontal" size="xs">
								<Button
									variant="link"
									onClick={() => this.setState({ showDeleteModal: false })}
									disabled={isDeleting}
								>
									Close
								</Button>
								<Button
									variant="primary"
									onClick={this.confirmDelete}
									loading={isDeleting}
									disabled={isDeleting}
								>
									Apply
								</Button>
							</SpaceBetween>
						</Box>
					}
				>
					Are you sure you want to delete {selectedItems.length} selected player ban(s)? This action cannot be undone.
				</Modal>

				<Table
					stickyHeader
					trackBy="id"
					selectionType="multi"
					selectedItems={selectedItems}
					onSelectionChange={({ detail }) => this.setState({ selectedItems: detail.selectedItems })}
					loading={!playerHidePayway.loaded}
					sortingColumn={{ sortingField: playerHidePayway.sorting.sortingColumn.column }}
					sortingDescending={playerHidePayway.sorting.isDescending}
					onSortingChange={(sorting) => {
						setPlayerHidePayway({
							...playerHidePayway,
							sorting: {
								...playerHidePayway.sorting,
								sortingColumn: {
									order: !sorting.detail.isDescending ? 'ASC' : 'DESC',
									column: sorting.detail.sortingColumn.sortingField,
								},
								isDescending: sorting.detail.isDescending,
							},
						});
						setTimeout(() => {
							this.props.Interface.loadPlayerHidePayway();
						}, 250);
					}}
					columnDefinitions={[
						{
							id: 'id',
							header: 'ID',
							sortingField: 'id',
							cell: (item) => (
								<Button
									variant="link"
									onClick={() => {
										const preItem = cloneDeep(item);
										const { id } = preItem;

										delete preItem.id;
										delete preItem.createdAt;

										setPlayerHidePaywayEditModal({
											...playerHidePaywayEditModal,
											id,
											...preItem,
											show: true,
											banType: preItem.toDate ? {  value: "date", label: "Date" } : { value: "forbidden", label: "Forbidden" },
											date: preItem.toDate ? preItem.toDate: false,
										});
									}}
								>
									{item.id}
								</Button>
							),
						},
						{
							id: "uid",
							header: "UID",
							sortingField: "uid",
							cell: (item) => (
								<Button
									className={this.props.styles?.["btnUID"]}
									variant="normal"
									onClick={() => {
										this.props.Interface.loadInfo(item.uid, item.brand);
									}}
									children={item.uid}
								/>
							),
						},
						{ id: 'group', header: 'Group', sortingField: 'group', cell: (item) => item.group || '-' },
						{
							id: 'toDate',
							header: 'toDate',
							sortingField: 'toDate',
							cell: (item) => item.toDate? new Date(item.toDate).toLocaleString(): "Forbidden",
						},
						{
							id: 'date',
							header: 'Created At',
							sortingField: 'date',
							cell: (item) => new Date(item.date).toLocaleString(),
						},
					]}
					items={playerHidePayway.data}
					preferences={
						<Preferences
							cancelLabel="Cancel"
							confirmLabel="Confirm"
							pageSizePreference={{ title: 'Player hidepayway per page', options: config.playerHidePayway.preferences.perPage }}
							preferences={{ pageSize: config.playerHidePayway.perPage }}
							title="Preferences"
							onConfirm={(preferences) => {
								localStorage.setItem('playerHidePayway.perPage', preferences.detail.pageSize);
								setConfig({ ...config, playerHidePayway: { ...config.playerHidePayway, perPage: preferences.detail.pageSize } });
								setTimeout(() => {
									this.props.Interface.loadPlayerHidePayway();
								}, 250);
							}}
						/>
					}
					pagination={
						<Pagination
							disabled={!playerHidePayway.loaded}
							currentPageIndex={playerHidePayway.pagination.current}
							pagesCount={playerHidePayway.pagination.total}
							onChange={(page) => {
								setPlayerHidePayway({ ...playerHidePayway, pagination: { ...playerHidePayway.pagination, current: page.detail.currentPageIndex } });
								setTimeout(() => {
									this.props.Interface.loadPlayerHidePayway();
								}, 250);
							}}
						/>
					}
					header={
						<Header
							variant="h1"
							description="Manage player hide payway"
							counter={`(${playerHidePayway.pagination.count})`}
							actions={
								<SpaceBetween direction="horizontal" size="xs">
										<Button
											variant="normal"
											iconName="remove"
											onClick={this.handleDeleteSelected}
											disabled={isDeleting || !selectedItems.length}
										>
											Delete Selected ({selectedItems.length})
										</Button>
									<Button
										iconName="add-plus"
										disabled={!playerHidePayway.loaded}
										variant="primary"
										onClick={() => {
											setPlayerHidePaywayAddModal({ ...playerHidePaywayAddModal, show: true });
										}}
									>
										Add player hide payway
									</Button>
								</SpaceBetween>
							}
						>
							Player hide payway
						</Header>
					}
					filter={
						<Box
							margin={{ bottom: "m" }}
							children={
								<Grid
									gridDefinition={[{ colspan: 3 }, { colspan: 3 }, { colspan: 3 }, { colspan: 3 }]}
									children={
										<>
											<Select
												filteringType="auto"
												disabled={!playerHidePayway.loaded}
												placeholder="Type"
												selectedOption={playerHidePayway.currentSearchType}
												onChange={(option) => {
													option.detail.selectedOption.type !== playerHidePayway.currentSearchType &&
													setPlayerHidePayway({
														...playerHidePayway,
														currentSearchType: option.detail.selectedOption,
													});
												}}
												options={[{ value: "uid", label: "uid" }, { value: "reason", label: "reason" }, { value: "id", label: "id" }]}
											/>
											<Input
												disabled={!playerHidePayway.loaded}
												onKeyDown={this.handleKeyPress}
												disableBrowserAutocorrect={true}
												placeholder="id, name"
												inputMode="search"
												type="search"
												value={playerHidePayway.currentSearch}
												onChange={(event) => {
													setPlayerHidePayway({
														...playerHidePayway,
														currentSearch: event.detail.value,
													});
												}}
											/>
										</>
									}
								/>
							}
						/>
					}
					empty={
						<Box textAlign="center" color="inherit">
							<b>No player hide payway found</b>
							<Box padding={{ bottom: 's' }} variant="p" color="inherit">
								No player hide payway match the current criteria.
							</Box>
							<Button
								onClick={() => setPlayerHidePaywayAddModal({ ...playerHidePaywayAddModal, show: true })}
							>
								Add player hide payway
							</Button>
						</Box>
					}
				/>
			</Container>
		);
	}
}

function withRecoil(Component) {
	return function WrappedComponent(props) {
		const playerHidePayway = useRecoilValue(playerHidePaywayStore);
		const setPlayerHidePayway = useSetRecoilState(playerHidePaywayStore);
		const config = useRecoilValue(configStore);
		const setConfig = useSetRecoilState(configStore);
		const playerHidePaywayAddModal = useRecoilValue(playerHidePaywayAddModalStore);
		const setPlayerHidePaywayAddModal = useSetRecoilState(playerHidePaywayAddModalStore);
		const playerHidePaywayEditModal = useRecoilValue(playerHidePaywayEditModalStore);
		const setPlayerHidePaywayEditModal = useSetRecoilState(playerHidePaywayEditModalStore);

		return (
			<Component
				{...props}
				playerHidePayway={playerHidePayway}
				setPlayerHidePayway={setPlayerHidePayway}
				config={config}
				setConfig={setConfig}
				playerHidePaywayAddModal={playerHidePaywayAddModal}
				setPlayerHidePaywayAddModal={setPlayerHidePaywayAddModal}
				playerHidePaywayEditModal={playerHidePaywayEditModal}
				setPlayerHidePaywayEditModal={setPlayerHidePaywayEditModal}
			/>
		);
	};
}

export default withRecoil(PlayerHidePayway);